module.exports = ".background{\r\n\tbackground-color: #081856;\r\n}\r\n.freedom{\r\n\tbackground-image: none;\r\n}"